export default "__VITE_ASSET__BGBVrUGA__"